import React from 'react';
import {format, isValid} from 'date-fns'
import PropTypes from 'prop-types';

const DateFormatRenderer = (props) => {
  let dateStr = '';
  if (props.value) {
    const dateObj = new Date(props.value);
    if (isValid(dateObj)) {
      dateStr = format(dateObj, "dd-MMM-yyyy");
    }
  }

  return <>{dateStr}</>;
};

DateFormatRenderer.propTypes = {
  value: PropTypes.any
};

export default DateFormatRenderer;
